if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const sheetAddToken = this.dataset.tqeSheetAddToken || '';
        const sheetAddVariantId = this.dataset.tqeSheetAddVariant || '';
        const hasSheetAddMarker = Boolean(sheetAddToken || sheetAddVariantId);
        delete this.dataset.tqeSheetAddToken;
        delete this.dataset.tqeSheetAddVariant;

        const sheetAddFormData = hasSheetAddMarker ? new FormData(this.form) : null;
        const submittedVariantId = sheetAddFormData ? String(sheetAddFormData.get('id') || '') : '';
        const isSheetAdd = Boolean(
          sheetAddToken && sheetAddVariantId && submittedVariantId === String(sheetAddVariantId)
        );

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          if (hasSheetAddMarker) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: sheetAddVariantId || submittedVariantId,
              submittedProductVariantId: submittedVariantId,
              errors: 'An add-to-cart request is already in progress.',
              message: 'Please wait a moment and try again.',
              tqeSheetAddToken: sheetAddToken,
              tqeSheetAddVariant: sheetAddVariantId,
            });
          }
          return;
        }

        if (hasSheetAddMarker && !isSheetAdd) {
          const message = 'The selected size changed before it could be added. Please select the size again.';
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: sheetAddVariantId || submittedVariantId,
            submittedProductVariantId: submittedVariantId,
            errors: message,
            message,
            tqeSheetAddToken: sheetAddToken,
            tqeSheetAddVariant: sheetAddVariantId,
          });
          this.handleErrorMessage(message);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = sheetAddFormData || new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (!isSheetAdd) this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        let sheetAddConfirmed = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
                ...(isSheetAdd
                  ? {
                      tqeSheetAddToken: sheetAddToken,
                      tqeSheetAddVariant: sheetAddVariantId,
                    }
                  : {}),
              });
              this.handleErrorMessage(response.description);

              if (isSheetAdd) {
                this.error = false;
                return;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !isSheetAdd) {
              window.location = window.routes.cart_url;
              return;
            }

            if (isSheetAdd) sheetAddConfirmed = true;
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (isSheetAdd || !this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
                ...(isSheetAdd
                  ? {
                      tqeSheetAddToken: sheetAddToken,
                      tqeSheetAddVariant: sheetAddVariantId,
                    }
                  : {}),
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            if (!this.cart) return;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      if (isSheetAdd) {
                        this.cart.renderContents(response, { open: false });
                      } else {
                        this.cart.renderContents(response);
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if (isSheetAdd) {
                  this.cart.renderContents(response, { open: false });
                } else {
                  this.cart.renderContents(response);
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
            if (isSheetAdd && !sheetAddConfirmed) {
              const message = 'We could not confirm whether this item was added. Please check your cart before trying again.';
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: message,
                message,
                tqeSheetAddToken: sheetAddToken,
                tqeSheetAddVariant: sheetAddVariantId,
                outcomeUnknown: true,
              });
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );

  window.tqeSheetAddCapabilities = window.tqeSheetAddCapabilities || {};
  window.tqeSheetAddCapabilities.productForm = 'v1';
}
